import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchToolAllowlist } from "./api";
import type { ToolAllowlistItem } from "./api";

// Разрешения пары (org, role). key включает roleName (свой кэш на каждую
// роль). Запрос отключён без выбранной роли — список появляется только
// после того, как человек выбрал роль в Select.
export function useToolAllowlist(
  roleName: string | null,
): UseQueryResult<readonly ToolAllowlistItem[], Error> {
  return useOrgScopedQuery<readonly ToolAllowlistItem[]>({
    key: ["toolAllowlist", roleName],
    // queryFn бежит только при enabled (roleName !== null) — non-null assert
    // безопасен, ветка `?? ""` иначе мёртвая (не покрывается тестом).
    queryFn: () => fetchToolAllowlist(roleName!),
    enabled: roleName !== null,
    retry: false,
  });
}
